import type { ClassificationPolicy } from '@repo/api-gw-sdk';

import { Tag } from '../tag';

export const ClassificationPolicyTag = ({
  policy,
}: {
  policy: ClassificationPolicy;
}) => {
  return (
    <Tag
      icon='material-symbols-avg-pace-rounded'
      content={policy.name}
      disabled={!policy.enabled}
      noWrap
    />
  );
};
